import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import ContactUs from "../components/ContactUs/ContactUs";
import backgroundImage from "../assets/Background_terafac1.png";

const ContactPage = () => {
  return (
    <div>
      <Navbar />
      <div className="contact-us-page">
        <div
          className="contact-page d-flex flex-column justify-content-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h1 className="lets-connect">Let's Connect</h1>
        </div>
        <div className="home-contact-space">
          <ContactUs />
        </div>
      </div>
      <Footer id="Footer-section" />
    </div>
  );
};

export default ContactPage;
